import { calculatePercj, calculatePlayerStats } from "./cabbStats";
export const radarDataForPlayer = (
  playerGames,
  activeProfile,
  playersArr,
  activeGames
) => {
  let totalGamesPlayed = 0;
  let totalGamesMissed = 0;
  let totalPoints = 0;
  let totalAssists = 0;
  let avgPoints = 0;
  let totalMinuts = 0;
  let made1Points = 0;
  let made2Points = 0;
  let made3Points = 0;
  let totalTl = 0;
  let total2Points = 0;
  let total3Points = 0;
  let rebTotal = 0;
  let offRebTotal = 0;
  let torTotal = 0;
  let blkTotal = 0;
  let stlTotal = 0;
  let recFoulsTotal = 0;
  let madFoulsTotal = 0;
  let madBlkTotal = 0;
  let recBlkTotal = 0;
  let radarData = 0;
  let values = [];

  let totalPts = 0;
  let totalAss = 0;
  let totalMins = 0;
  let gamesPlayed = 0;
  let total1pts = 0;
  let total2pts = 0;
  let total3pts = 0;
  let made1pts = 0;
  let made2pts = 0;
  let made3pts = 0;
  let rebTot = 0;
  let offRebTot = 0;
  let tor = 0;
  let stl = 0;
  let blk = 0;
  let recFouls = 0;
  let madeFouls = 0;
  let blocksRecibed = 0;
  let blocksMade = 0;
  for (var i = 0; i < playerGames.length; i++) {
    //points
    totalPts += Number(playerGames[i]["pts"]);
    //minutes
    let minutos = playerGames[i]["mins"].replace(":", ".");
    minutos.replace(":", ".");
    //assits
    totalAss += Number(playerGames[i]["ass"]);
    totalMins += Number(minutos);
    //games played
    if (Number(minutos) > 0) gamesPlayed += 1;
    //shotting %
    let tlPts = playerGames[i]["tlA/I"].split("/");
    total1pts += Number(tlPts[1]);
    made1pts += Number(tlPts[0]);
    let twoPts = playerGames[i]["2pA/I"].split("/");
    total2pts += Number(twoPts[1]);
    made2pts += Number(twoPts[0]);
    let trheePts = playerGames[i]["3pA/I"].split("/");
    total3pts += Number(trheePts[1]);
    made3pts += Number(trheePts[0]);
    //end of shooting %
    rebTot += Number(playerGames[i]["rebTot"]);
    offRebTot += Number(playerGames[i]["rebOff"]);
    stl += Number(playerGames[i]["rec"]);
    blk += Number(playerGames[i]["blocksMade"]);
    tor += Number(playerGames[i]["per"]);
    madeFouls += Number(playerGames[i]["foulsMade"]);
    recFouls += Number(playerGames[i]["foulesRecibed"]);
    blocksRecibed += Number(playerGames[i]["blocksRecibed"]);
    blocksMade += Number(playerGames[i]["blocksMade"]);
  }

  totalPoints = totalPts;
  totalGamesPlayed = gamesPlayed;
  totalGamesMissed = playerGames.length - gamesPlayed;
  avgPoints = Math.round((totalPts / gamesPlayed) * 10) / 10;
  totalMinuts = totalMins;
  totalAssists = totalAss;
  totalTl = total1pts;
  made1Points = made1pts;
  made2Points = made2pts;
  total2Points = total2pts;
  made3Points = made3pts;
  total3Points = total3pts;
  rebTotal = rebTot;
  blkTotal = blk;
  stlTotal = stl;
  torTotal = tor;
  madFoulsTotal = madeFouls;
  recFoulsTotal = recFouls;
  madBlkTotal = blocksMade;
  recBlkTotal = blocksRecibed;
  offRebTotal = offRebTot;
  const playMaking = totalAssists / torTotal;
  let FG = made2Points + made3Points;
  let FGA = total2Points + total3Points;
  let EFG = Math.round(((FG + 0.5 * total3Points) / FGA) * 100);
  let TS = 0.5 * (totalPoints / FGA) + 0.44 * totalTl;
  let TSP = ((0.5 * totalPoints) / [FGA + 0.44 * totalTl]) * 100;
  const shooting = (EFG + TSP) / 2;
  let scorinig = ((totalPoints - 20) / (100 - 10)) * 100;
  let offensiveAggressiveness = recFoulsTotal + offRebTotal;
  let defensiveAggressiveness = stlTotal + madBlkTotal + madFoulsTotal;
  let cAndS =
    (calculatePercj(activeGames, activeProfile[0].active_team, "ASSTot") / FG) *
    10;
  let usage =
    (100 *
      ((FGA + 0.44 * (totalTl + torTotal)) * (totalGamesPlayed * 40 * 5))) /
    ((calculatePercj(activeGames, activeProfile[0].active_team, "FGATot") +
      0.44 *
        (calculatePercj(activeGames, activeProfile[0].active_team, "FTTot") +
          calculatePercj(
            activeGames,
            activeProfile[0].active_team,
            "TORTot"
          ))) *
      5 *
      totalMins);
  let GtG =
    (totalMins * usage) /
    calculatePercj(activeGames, activeProfile[0].active_team, "POSSTot");
  let oreb = calculatePlayerStats(activeGames, activeProfile[0]._id, "OREB");
  values = [
    Math.round((defensiveAggressiveness / totalGamesPlayed) * 10),
    Math.round(
      offensiveAggressiveness / totalGamesPlayed === 1
        ? (offensiveAggressiveness / totalGamesPlayed) * 1
        : (offensiveAggressiveness / totalGamesPlayed) * 10
    ),
    Math.round(
      cAndS >= 0 && cAndS <= 100
        ? cAndS
        : cAndS < 0
        ? 0
        : cAndS > 100 && cAndS !== Infinity
        ? 100
        : isNaN(cAndS)
        ? 0
        : cAndS === Infinity
        ? 0
        : null
    ),
    Math.round(
      GtG * 10 >= 0 && GtG * 10 <= 100
        ? GtG * 10
        : GtG * 10 < 0
        ? 0
        : GtG * 10 > 100
        ? 100
        : isNaN(GtG) || Infinity
        ? 0
        : null
    ),
    Math.round((avgPoints * 100) / playersArr[0].value),
    Math.round(isNaN(shooting) || shooting === Infinity ? 0 : shooting),
    Math.round(
      playMaking * 30 >= 0 && playMaking * 30 <= 100
        ? playMaking * 30
        : playMaking * 30 < 0
        ? 0
        : playMaking * 30 > 100
        ? 100
        : isNaN(playMaking) || playMaking === Infinity
        ? 0
        : null
    ),
  ];
  return values;
};
